import { LOCALE } from "../../../../properties/Locale";
import * as yup from "yup";

export const administratorCreateUserForm = yup.object().shape({
  firstName: yup
    .string()
    .required(LOCALE.login_firstname + LOCALE.required_field),
  lastName: yup
    .string()
    .required(LOCALE.login_lastname + LOCALE.required_field),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  username: yup
    .string()
    .required(LOCALE.login_username + LOCALE.required_field),
  password: yup
    .string()
    .required(LOCALE.login_password + LOCALE.required_field),
});

export const advisorCreateUserForm = yup.object().shape({
  firstName: yup
    .string()
    .required(LOCALE.login_firstname + LOCALE.required_field),
  lastName: yup
    .string()
    .required(LOCALE.login_lastname + LOCALE.required_field),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  username: yup
    .string()
    .required(LOCALE.login_username + LOCALE.required_field),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  password: yup
    .string()
    .required(LOCALE.login_password + LOCALE.required_field),
});

export const commissionCreateUserForm = yup.object().shape({
  name: yup.string().required(LOCALE.name + LOCALE.required_field),
  username: yup
    .string()
    .required(LOCALE.login_username + LOCALE.required_field),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  password: yup
    .string()
    .required(LOCALE.login_password + LOCALE.required_field),
});

export const schoolCreateUserForm = yup.object().shape({
  name: yup.string().required(LOCALE.name + LOCALE.required_field),
  schoolId: yup
    .string()
    .nullable()
    .required(LOCALE.school + LOCALE.required_field),
  username: yup
    .string()
    .required(LOCALE.login_username + LOCALE.required_field),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
  password: yup
    .string()
    .required(LOCALE.login_password + LOCALE.required_field),
});

export const teacherCreateUserForm = yup.object().shape({
  teacher: yup.object().shape({
    firstName: yup
      .string()
      .required(LOCALE.login_firstname + LOCALE.required_field),
    lastName: yup
      .string()
      .required(LOCALE.login_lastname + LOCALE.required_field),
  }),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
});

export const associateCreateUserForm = yup.object().shape({
  teacher: yup.object().shape({
    firstName: yup
      .string()
      .required(LOCALE.login_firstname + LOCALE.required_field),
    lastName: yup
      .string()
      .required(LOCALE.login_lastname + LOCALE.required_field),
  }),
  email: yup
    .string()
    .required(LOCALE.login_email + LOCALE.required_field)
    .email(LOCALE.invalid_email_address_format),
});
